import React from 'react';
import { ChevronDownIcon, UserIcon } from 'lucide-react';
import { ALL_LOAN_OFFICERS } from '../App';
interface DashboardHeaderProps {
  selectedTeam: string;
  setSelectedTeam: (team: string) => void;
  dateRange: string;
  setDateRange: (range: string) => void;
  selectedLO: string;
  setSelectedLO: (lo: string) => void;
}
export function DashboardHeader({
  selectedTeam,
  setSelectedTeam,
  dateRange,
  setDateRange,
  selectedLO,
  setSelectedLO
}: DashboardHeaderProps) {
  return <header className="bg-white border-b border-gray-200" data-id="element-8">
      <div className="max-w-[1600px] mx-auto px-6 py-6" data-id="element-9">
        <div className="flex items-center justify-between" data-id="element-10">
          <div data-id="element-11">
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-12">
              Coaching Corner
            </h1>
            <p className="text-sm text-gray-600 mt-1" data-id="element-13">
              Manager coaching hub for LO performance visibility and
              intervention
            </p>
          </div>

          <div className="flex items-center gap-4" data-id="element-14">
            <div className="relative" data-id="element-15">
              <UserIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none" data-id="element-16" />
              <select value={selectedLO} onChange={e => setSelectedLO(e.target.value)} className="appearance-none bg-white border border-gray-300 rounded-lg pl-9 pr-10 py-2 text-sm font-medium text-gray-700 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer" data-id="element-17">
                <option value="all" data-id="element-18">All Loan Officers</option>
                {ALL_LOAN_OFFICERS.map(lo => <option key={lo} value={lo} data-id="element-19">
                    {lo}
                  </option>)}
              </select>
              <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none" data-id="element-20" />
            </div>

            <div className="relative" data-id="element-21">
              <select value={selectedTeam} onChange={e => setSelectedTeam(e.target.value)} className="appearance-none bg-white border border-gray-300 rounded-lg px-4 py-2 pr-10 text-sm font-medium text-gray-700 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer" data-id="element-22">
                <option value="all" data-id="element-23">All Teams</option>
                <option value="team-a" data-id="element-24">Team A</option>
                <option value="team-b" data-id="element-25">Team B</option>
                <option value="team-c" data-id="element-26">Team C</option>
              </select>
              <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none" data-id="element-27" />
            </div>

            <div className="relative" data-id="element-28">
              <select value={dateRange} onChange={e => setDateRange(e.target.value)} className="appearance-none bg-white border border-gray-300 rounded-lg px-4 py-2 pr-10 text-sm font-medium text-gray-700 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer" data-id="element-29">
                <option value="last-7-days" data-id="element-30">Last 7 Days</option>
                <option value="last-30-days" data-id="element-31">Last 30 Days</option>
                <option value="last-90-days" data-id="element-32">Last 90 Days</option>
                <option value="ytd" data-id="element-33">Year to Date</option>
              </select>
              <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none" data-id="element-34" />
            </div>
          </div>
        </div>

        {selectedLO !== 'all' && <div className="mt-4 flex items-center gap-2" data-id="element-35">
            <span className="text-xs text-gray-500" data-id="element-36">Filtering by:</span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-blue-50 text-blue-700 text-sm font-medium rounded-full border border-blue-200" data-id="element-37">
              <UserIcon className="w-3.5 h-3.5" data-id="element-38" />
              {selectedLO}
              <button onClick={() => setSelectedLO('all')} className="ml-1 hover:text-blue-900 transition-colors" aria-label="Clear LO filter" data-id="element-39">
                ×
              </button>
            </span>
          </div>}
      </div>
    </header>;
}